export enum COLLECTION_CONTENT_TYPES {
  BLOG = 'BLOG',
  WORKOUT = 'WORKOUT',
  RECIPE = 'RECIPE',
  AUDIO = 'AUDIO',
  SERIES = 'SERIES',
  MINIS = 'MINIS',
}

export enum COLLECTION_ITEM_TYPES {
  MINI = 'MINI',
  SERIES = 'SERIES',
}
